import { Component, ViewChild, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { DropDown, SalesMessageModalComponent } from "app/components";
import { ConsultingMonitoringService, SalesManagerService } from "app/services";
import { UserSalesMessage } from "app/services/sales.service";
import { ConsultRequestSummaryData } from "app/services/sales/model/ConsultRequestSummaryData";
import { ConsultingMonitoringViewModel } from "./consulting-monitoring.viewmodel";

@Component({
    selector: 'consulting-monitoring',
    templateUrl: 'consulting-monitoring.html',
    styleUrls: ['sales.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ConsultingMonitoring {

    @ViewChild('dropdownQuery') dropdownQuery: DropDown<string>;
    @ViewChild('dropdownSalesManager') dropdownSalesManager: DropDown<string>;
    @ViewChild('salesMessageModal') salesMessageModal: SalesMessageModalComponent;
    
    private viewModel: ConsultingMonitoringViewModel;


    constructor(private consultingMonitoringService: ConsultingMonitoringService, private salseManagerService: SalesManagerService, private router: Router) {
        this.viewModel = new ConsultingMonitoringViewModel(consultingMonitoringService, salseManagerService, router);
        this.viewModel.showMessageBtnCallback = (data: ConsultRequestSummaryData) => {
          this.salesMessageModal.open(data.userId, data.fullName, data.jobTpText, data.cmpnyNm);
        };
    }


    onBodyClick(event?: UIEvent): void {
        if (event && event.target) {
            if (event.target['parentElement'] != this.dropdownQuery.elementRef.nativeElement) {
                this.dropdownQuery.close();
            }

            if (event.target['parentElement'] != this.dropdownSalesManager.elementRef.nativeElement) {
                this.dropdownSalesManager.close();
            }
        }
    }
    
}


// WEBPACK FOOTER //
// ./src/app/containers/sales/consulting-monitoring.ts